"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Tooltip/ControlledTooltip.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);






var _common = require('web/components/Tooltip/common');
var _keyboard = require('web/services/keyboard');




















const createInitialState = () => ({
  tooltipPosition: {},
  tooltipArrowPosition: {},
})

// Not memoized, like the class it replaces: callers pass fresh `children`
// (and usually `content`) elements on every render, so a memo would never hit.
const ControlledTooltip = ({
  children, className, tooltipClassName, domTarget, offset, fixedPosition,
  fullContentWidth,
  isOpen = false,
  isDismissibleByClick = false,
  isDismissibleByClickElsewhere = true,
  isAnimated = false,
  hasCloseButton = false,
  content = _common.DEFAULT_CONTENT,
  hideArrow = false,
  type = _common.DEFAULT_TYPE,
  place = _common.DEFAULT_PLACE,
  onClose = _common.noop,
}) => {
  const [state, setState] = _react.useState.call(void 0, createInitialState)
  const { tooltipPosition, tooltipArrowPosition, domTargetRect } = state

  const targetRef = _react.useRef(null)
  const tooltipRef = _react.useRef(null)

  // The window listener runs after later renders; like the class reading
  // this.props.onClose, it calls the latest committed onClose.
  const onCloseRef = _react.useRef.call(void 0, onClose)
  _react.useLayoutEffect.call(void 0, () => {
    onCloseRef.current = onClose
  })

  // One stable function, so removeEventListener matches what was added.
  const handleClickElsewhere = _react.useCallback.call(void 0, () => onCloseRef.current(), [])

  // To prevent it from triggering by
  // events that are happening at the
  // very moment component is mounted.
  const addClickElsewhereListener = _react.useCallback.call(void 0, () => setTimeout(
    () => window.addEventListener('click', handleClickElsewhere), 0,
  ), [handleClickElsewhere])

  const removeClickElsewhereListener = _react.useCallback.call(void 0, 
    () => window.removeEventListener('click', handleClickElsewhere),
    [handleClickElsewhere],
  )

  // Called only from the effects below, so it reads this render's props.
  const updateTooltipPosition = () => {
    const target = domTarget || targetRef.current

    if (!target) return

    const nextTooltipPosition = fixedPosition ||
      _common.getTooltipPosition.call(void 0, target, tooltipRef.current, place, hideArrow, offset)
    const nextDomTargetRect = fullContentWidth
      ? target.getBoundingClientRect()
      : undefined

    const nextTooltipArrowPosition = _common.getToolTipArrowPosition.call(void 0, 
      target, nextTooltipPosition, place,
    )

    setState(s => ({
      ...s,
      ...(nextDomTargetRect && { domTargetRect: nextDomTargetRect }),
      tooltipPosition: nextTooltipPosition,
      tooltipArrowPosition: nextTooltipArrowPosition,
    }))
  }

  // componentDidMount / componentWillUnmount.
  _react.useLayoutEffect.call(void 0, () => {
    if (isOpen) {
      if (isDismissibleByClickElsewhere) addClickElsewhereListener()
      updateTooltipPosition()
    }
    return removeClickElsewhereListener
    // Mount/unmount only, as the class lifecycles were.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // componentDidUpdate: compares against the previous render's props.
  const prevPropsRef = _react.useRef(null)
  _react.useLayoutEffect.call(void 0, () => {
    const prevProps = prevPropsRef.current
    prevPropsRef.current = { isOpen, domTarget, content }
    if (!prevProps) return

    if (isDismissibleByClickElsewhere) {
      if (prevProps.isOpen && !isOpen) removeClickElsewhereListener()
      if (!prevProps.isOpen && isOpen) addClickElsewhereListener()
    }
    if (
      prevProps.domTarget !== domTarget ||
      prevProps.content !== content ||
      !prevProps.isOpen && isOpen
    ) { updateTooltipPosition() }
  })

  // Escape, pressed on the control that opened the tooltip or inside it,
  // closes it, and focus inside it goes back to that control. This listens on
  // keyup, as Modal does, and stops there, so a menu inside a dialog closes
  // alone.
  _react.useEffect.call(void 0, () => {
    if (!isOpen) return
    const handleEscape = (e) => {
      if (e.key !== 'Escape' || !_optionalChain([targetRef, 'access', _ => _.current, 'optionalAccess', _2 => _2.contains, 'call', _3 => _3(document.activeElement)])) return
      e.stopPropagation()
      const tooltip = tooltipRef.current
      if (_optionalChain([tooltip, 'optionalAccess', _4 => _4.contains, 'call', _5 => _5(document.activeElement)])) {
        const focusable = _optionalChain([targetRef, 'access', _6 => _6.current, 'optionalAccess', _7 => _7.querySelectorAll, 'call', _8 => _8(
          'button, a[href], input, [tabindex]:not([tabindex="-1"])',
        )])
        const trigger = [...(_nullishCoalesce(focusable, () => ( [])))].find(el => !tooltip.contains(el))
        _optionalChain([trigger, 'optionalAccess', _9 => _9.focus, 'call', _10 => _10()])
      }
      onCloseRef.current()
    }
    document.addEventListener('keyup', handleEscape)
    return () => document.removeEventListener('keyup', handleEscape)
  }, [isOpen])

  const handleTooltipClick = _react.useCallback.call(void 0, 
    (e) => !isDismissibleByClick && e.stopPropagation(),
    [isDismissibleByClick],
  )

  // Reuses the merged style object until its inputs change, so the tooltip body
  // does not get a new style identity on every render.
  const domTargetWidth = _optionalChain([domTargetRect, 'optionalAccess', _11 => _11.width])
  const bodyStyle = _react.useMemo.call(void 0, 
    () => fullContentWidth
      ? { ...tooltipPosition, width: domTargetWidth }
      : tooltipPosition,
    [fullContentWidth, tooltipPosition, domTargetWidth],
  )

  const rootClassName = _classBuilder2.default.call(void 0, 'blm-tooltip--container', className)
  const tooltipBodyClassName = _classBuilder2.default.call(void 0, 
    'blm-tooltip',
    _common.getTooltipTypeClass.call(void 0, { type, place }),
    { hidden: !isOpen, animated: isAnimated },
    tooltipClassName,
  )

  return (
    _react2.default.createElement('div', {
      'aria-live': "assertive",
      className: rootClassName,
      ref: targetRef, __self: this, __source: {fileName: _jsxFileName, lineNumber: 180}}

      , children
      ,  content && (_react2.default.createElement('div', {
        'aria-hidden': !isOpen,
        role: "alertdialog",
        className: tooltipBodyClassName,
        style: bodyStyle,
        ref: tooltipRef,
        onClick: handleTooltipClick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 186}}

        ,  hasCloseButton && (
          _react2.default.createElement('div', {
            'aria-label': "Close",
            role: "button", tabIndex: 0, onKeyDown: _keyboard.onButtonKeyDown,
            className: "blm-tooltip--close-btn",
            onClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 195}}
          )
        )
        ,  !hideArrow && (
          _react2.default.createElement('div', { className: "blm-tooltip--arrow", style: tooltipArrowPosition, __self: this, __source: {fileName: _jsxFileName, lineNumber: 203}} )
        )
        , content
      ))
      
    )
  )
}

exports. default = ControlledTooltip
